import { render, staticRenderFns } from "./MobileSavingIcon.vue?vue&type=template&id=1131b628"
import script from "./MobileSavingIcon.vue?vue&type=script&lang=js"
export * from "./MobileSavingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports